import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class ClaimService {
  baseUrl: string = environment.api_base_url;
  constructor(public http: HttpClient) {}
  getClaims(params = {}): any {
    return this.http.get(`${this.baseUrl}claims`, {
      params: Object.entries(params)
        .filter(([key, val]) => val)
        .reduce((obj, [key, val]) => {
          obj[key] = val;
          return obj;
        }, {}),
    });
  }

  getClaim(claim_id): any {
    return this.http.get(`${this.baseUrl}claims/${claim_id}`);
  }

  getReservationStatement(reservation_id, params = {}): any {
    return this.http.get(
      `${this.baseUrl}financial/reservation_statement/${reservation_id}`,
      {
        params: Object.entries(params)
          .filter(([key, val]) => val)
          .reduce((obj, [key, val]) => {
            obj[key] = val;
            return obj;
          }, {}),
      }
    );
  }

  calcClaimAmount(reservation_id, params = {}): any {
    return this.http.get(
      `${this.baseUrl}claims/${reservation_id}/calculate_claim_amount`,
      {
        params: Object.entries(params)
          .filter(([key, val]) => val)
          .reduce((obj, [key, val]) => {
            obj[key] = val;
            return obj;
          }, {}),
      }
    );
  }

  storeClaim(reservation_id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}claims/${reservation_id}/store`,
      payload
    );
  }

  collectClaim(reservation_id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}claims/${reservation_id}/collect`,
      payload
    );
  }

  deleteClaim(reservation_id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}claims/${reservation_id}/delete`,
      payload
    );
  }

  createClaim(payload) {
    return this.http.post(`${this.baseUrl}demands`, payload);
  }

  getClaimsTab(id?) {
    if (id) return this.http.get(`${this.baseUrl}demands?reservation_id=${id}`);
    return this.http.get(`${this.baseUrl}demands`);
  }

  getAllClaims(filters = {}) {
    return this.http.get(`${this.baseUrl}demands`, { params: filters });
  }

  assignClaim(payload) {
    return this.http.post(`${this.baseUrl}demands/assignClaims`, payload);
  }

  getETAClaims(id) {
    return this.http.get(`${this.baseUrl}demands/${id}`);
  }

  deletePayment(id) {
    return this.http.delete(`${this.baseUrl}demands/${id}`);
  }

  getAccountants() {
    return this.http.get(`${this.baseUrl}users/get_accountants`);
  }

  getItemDetails(demand_id) {
    return this.http.get(`${this.baseUrl}demands/${demand_id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/claims-view/claim.service.ts